import React, { Component } from 'react';
import {connect} from 'react-redux';

import classes from './Home.css';
import Logo from '../../components/Logo/Logo';
import Button from '../../components/UI/Button/Button';
import Img from '../../assets/images/img1.jpg';
import BackImage from '../../components/BackImg/BackImg';
import Spacer from '../../components/Spacer/Spacer';
import SideNav from '../../components/Navigation/SideNavItems/SideNavItems';
import Services from './Services/Services';
import SideScroll from '../../components/Navigation/SideScroll/SideScroll';
import Section from '../../hoc/Section/Section';
import ScrollHandler from '../../hoc/ScrollHandler';
import Companies from '../../components/Companies/Companies';
import Title from '../../components/Title/Title';
import Contact from './Contact/Contact';
import About from './About/About';
import Team from './Team/Team';
import ScrollTo from '../../hoc/scrollToComponent';
import Citation from '../../components/Citation/Citation';

import Testimonials from '../../components/Testimonials/Testimonials';


class Home extends Component {
    
    state = {
        scrolled: false,
        sideNavColor: this.props.color,
        sideScrollColor: this.props.color,
    }

    scrollHandler = () => {
        if(window.pageYOffset > 30) {
            if(!this.state.scrolled) this.setState({scrolled: true});
        } else {
            this.setState({scrolled: false});
        }
    }

    render () {

        return (
            <ScrollHandler onWindowScroll={this.scrollHandler}>
                <div key="home" className={classes.Main}>
                    <div style={{position: "absolute", top: "100px", left: "0"}}>
                        <Section link="/" mainSection="/"/>
                    </div>

                    <BackImage image={Img} isFixed/>

                    <SideNav 
                            color= {this.props.color} 
                            color2="white"
                             />
                    <SideScroll 
                            up={(this.state.scrolled && !this.props.isMobile()) ? true : false}
                            element="/#whoweare"
                            />

                    <div className={classes.Home}>
                        <div className={classes.Animation}>
                            <Logo animated={true} />
                        </div>
                        <ScrollTo className={classes.DivButton} element="/#whoweare">
                            <Button 
                                    color={this.props.color}
                                    borderColor={this.props.color}
                                    bgColor2={this.props.color}
                                    bgColor1="#3D9842">About Us</Button>
                        </ScrollTo>
                        <Spacer height='100px' noBg/>
                        
                        <Citation author="Colin Powell" style={{color: this.props.color, textAlign: "right", transform: "translateX(20%)"}}>
                            There are no secrets to success. It is the result of preparation, hard work, and learning from failure.
                        </Citation>

                    </div>

                    <div className={classes.Container}>

                        <Spacer height="50px" />

                        <About color={this.props.color} />

                        <Services 
                                color={this.props.color}
                                color2="#3D9842" 
                                gradient1={this.props.riseUpBlue}
                                gradient2={this.props.riseUpGreen}
                                isMobile={this.props.isMobile}/>

                        <Spacer height="100px" />

                        <Testimonials style={{color: "darkgray"}}/>

                        <Companies color={this.props.color} color2="#3D9842" />

                        <Spacer height="100px" />

                        <Team 
                                color={this.props.color} 
                                color2="#3D9842"
                                isMobile={this.props.isMobile}/>

                        <Spacer height="100px" />

                        <Title  title1="Let's Work"
                                title2="Together"
                                color1={this.props.color}
                                color2="#3D9842"/>
                        
                        <Contact />

                        <Spacer height="100px" />
                        
                    </div>
                </div>
            </ScrollHandler>
        );
    }
        
}

const mapStateToProps = state => {
    return {
        color: state.textColor,
        riseUpGreen: state.riseUpGreen,
        riseUpBlue: state.riseUpBlue
    }
}

export default connect(mapStateToProps)(Home);


// WEBPACK FOOTER //
// ./client/src/containers/Home/Home.js